import * as React from 'react';
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Motion, spring } from 'react-motion';
import * as GoogleAnalytics from 'react-ga';

import Utils, { breakpoints, SecurityRoles as roles } from '../../common/utils';
import * as navActions from './navActions';
import NavButton from './NavButton';
import NavItem from './NavItem';
import { IconBrand } from '../icons';
import LoginWelcome from '../../auth/LoginWelcome';
import AdminNavBar from './AdminNavBar';
import CustomerNavBar from './CustomerNavBar';

interface Props {
	actions: any;
	menuIsOpen: boolean;
	currentUser: UserDetails;
}
class NavBar extends React.Component<Props, any> {
	constructor(props: any) {
		super(props);
	}

	componentWillReceiveProps(nextProps: any) {
		if (nextProps.menuIsOpen) {
			Utils.disableBodyScrolling({className: 'nav-open'});
		} else {
			const bodyEl = document.querySelector('body');
			if (bodyEl && bodyEl.classList.contains('nav-open')) {
				Utils.enableBodyScrolling({className: 'nav-open'});
			}
		}
	}

	toggleNavMenu = () => {
		if (window.innerWidth < breakpoints.xl) {
			this.props.actions.toggleNavigation();
		}
	}

	getQuote = () => {
		this.toggleNavMenu();

		const abTestIndex = Utils.getABTestOptimizeIndex();
		GoogleAnalytics.set({'exp': `Szj9gW87RKe5Yo5GErN82A.${abTestIndex}`});

		const url = Utils.getABTestWorkflowUrl(abTestIndex);
		window.location.href = url;
	}

	render() {
		const { menuIsOpen } = this.props;
		const customerAuthProps = { rolesRequired: [roles.Customer], currentUser: this.props.currentUser };
		const adminAuthProps = {
			currentRoles: this.props.currentUser.role as any,
		};

		return (
			<div className="navbar-wrapper fixed-top bg-light no-print" data-adjust-fixed-scrollbar={true}>
				<div className="container px-0">
					<nav className="navbar navbar-expand-xl pr-0">
						{/*  Haven't tested customer login yet!!!  */}
						{(this.props.currentUser.role !== undefined) && (this.props.currentUser.role[0] === 'Customer') && 
							<Link className="navbar-brand" to="/">
							<IconBrand />
						</Link>}
						<NavButton className={`navbar-toggler${menuIsOpen ? '' : ' collapsed'}`} onClick={this.toggleNavMenu} />
						<Motion
							style={{
								x: spring(menuIsOpen ? 0 : -100, {
									stiffness: 300,
									damping: 30
								})
							}}
						>
							{({ x }) => (
								<div
									className={`navbar-collapse${menuIsOpen ? '' : ' collapse'}`}
									style={{
										display: x === -100 ? 'none' : 'block',
										WebkitTransform: `translate(0, ${x}%)`,
										transform: `translate(0, ${x}%)`
									}}
								>
									<div className="container px-0 d-xl-flex">
										<ul className="navbar-nav mb-5 d-xl-none">
											<li className="nav-item">
												<Link to="/" onClick={this.toggleNavMenu} className="nav-item-brand">
													<IconBrand />
												</Link>
											</li>
										</ul>
										<LoginWelcome className="d-xl-none" onClick={this.toggleNavMenu} />
										<AdminNavBar onClick={this.toggleNavMenu} {...adminAuthProps} />
										<CustomerNavBar onClick={this.toggleNavMenu} {...customerAuthProps} />
										<ul
											className={`navbar-nav navbar-nav-separator ml-xl-auto${
												this.props.currentUser.isAuthenticated ? ' d-xl-none' : ''
											}`}
										>
											<NavItem
												to="#"
												onClick={this.getQuote}
												className="nav-item-em"
												linkClassName="text-primary"
											>
												<strong>Get an easy quote</strong>
											</NavItem>
											<NavItem to="/faq" onClick={this.toggleNavMenu}>
												FAQ
											</NavItem>
											<NavItem to="/about-us" onClick={this.toggleNavMenu}>
												About mosaic life
											</NavItem>
											<li className="nav-item">
												<a className="nav-link" aria-current="false" href="https://blog.insuredbymosaic.ca">
													<span className="nav-link-label">Blog</span>
												</a>
											</li>
											<NavItem
												to="/claims"
												className={this.props.currentUser.isAuthenticated ? 'd-none' : ''}
												onClick={this.toggleNavMenu}
											>
												Make a claim
											</NavItem>
										</ul>
										<ul className="navbar-nav mt-4 d-xl-none">
											<NavItem className="reduced-em">
												<small className="reduced-em">Version {process.env.REACT_APP_Version}</small>
											</NavItem>
										</ul>
										<LoginWelcome className="d-none d-xl-block" onClick={this.toggleNavMenu} />
									</div>
								</div>
							)}
						</Motion>
					</nav>
				</div>
			</div>
		);
	}
}

function mapStateToProps(state: any, ownProps: any) {
	return {
		menuIsOpen: state.nav.menuIsOpen,
		currentUser: state.auth.currentUser
	};
}
function mapDispatchToProps(dispatch: any) {
	return {
		actions: bindActionCreators(Object.assign({}, navActions as any), dispatch)
	};
}
// Added {pure: false} to get the active NavLinks to update when going forward/back via history,
// which will force a re-render. Not sure if this is the optimal solution.
// https://github.com/ReactTraining/react-router/issues/3536
export default connect(mapStateToProps, mapDispatchToProps, null, { pure: false })(NavBar);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/navigation/NavBar.tsx